import script from "./EvaluacionProcesoView.vue?vue&type=script&setup=true&lang=js"
export * from "./EvaluacionProcesoView.vue?vue&type=script&setup=true&lang=js"

import "./EvaluacionProcesoView.vue?vue&type=style&index=0&id=3813482f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3813482f"]])

export default __exports__